import React, {useContext} from 'react';
import LangContext from '../../context/LangContext';
import {Typography} from '@material-ui/core/';
import appel1 from './Material/Appel1.jpg';
import appel2 from './Material/Appel2.jpg';


export const Appeldalendescription = (props) => {
  const [lang] = useContext(LangContext);
    return <>
      {lang==="se" ? <>
        <Typography variant="h5" gutterBottom>
          Äppeldalen
        </Typography>
        <img style={{width: 320}} src={appel1} alt="appel" /><br/>
        <img style={{width: 320}} src={appel2} alt="appel" /><br/>
        </> : <>
        <Typography variant="h5" gutterBottom>
          Omenapuutarha
        </Typography>
        <img style={{width: 320}} src={appel1} alt="appel" /><br/>
        <img style={{width: 320}} src={appel2} alt="appel" /><br/>
      </>}
    </>
};

export default Appeldalendescription;